export default __webpack_public_path__ + "static/media/cooking_sm.c18b69fe.jpg";